// extracted by mini-css-extract-plugin
export default {"wrapper":"MessagesList_wrapper__t+cjf","messagesWrapper":"MessagesList_messagesWrapper__jC5SK","messages":"MessagesList_messages__WmKx4"};